import type { LeaderboardEntryPublic } from "@softmax/observatory-client/types";
import type { RoundEpisodeRow } from "../round-episodes";

export function episodeRoster({
  episode,
  leaderboard,
}: {
  readonly episode: RoundEpisodeRow;
  readonly leaderboard: readonly LeaderboardEntryPublic[];
}): {
  seats: number;
  roster: string[];
} {
  const seated = episode.participants.filter(
    (
      participant,
    ): participant is Extract<
      (typeof episode.participants)[number],
      {
        kind: "policy";
      }
    > =>
      participant.kind === "policy" &&
      !participant.is_filler &&
      !participant.is_seed,
  );
  const rankOf = new Map(
    leaderboard.map((entry) => [entry.player_id, entry.rank]),
  );
  const seen = new Set<string>();
  const roster = seated
    .flatMap((participant) => {
      if (!participant.player_id) return [];

      const name = participant.player_name || "unknown";
      const suffix = participant.owner_name
        ? ` (${participant.owner_name})`
        : "";
      return [
        {
          id: participant.player_id,
          name:
            participant.player_name && suffix && !name.endsWith(suffix)
              ? `${name}${suffix}`
              : name,
          rank: rankOf.get(participant.player_id) ?? Number.MAX_SAFE_INTEGER,
        },
      ];
    })
    .toSorted((a, b) => a.rank - b.rank)
    .filter((entry) => {
      if (seen.has(entry.id)) return false;

      seen.add(entry.id);
      return true;
    })
    .map((entry) => entry.name);
  return { seats: seated.length, roster };
}
